import { CANADIAN_PROVINCE_CODES } from '@/consts/enums'
import enumsHelper from '@/helpers/enums'

const defaultProvinceCode = 'QC'

const getProvinceTranslation = code => enumsHelper.formatProvince(code)

const getAllProvinces = () => {
  return CANADIAN_PROVINCE_CODES.map(code => ({
    value: code,
    text: getProvinceTranslation(code)
  }))
}

export default {
  defaultProvinceCode,
  getAllProvinces,
  getProvinceTranslation
}
